import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import AllQueriesContent from "./AllQueriesContent";

interface AllQueriesProps {
  queryHash?: string;
}

const AllQueries = ({ queryHash }: AllQueriesProps) => {
  return (
    <DatatableContextProvider>
      <AllQueriesContent queryHash={queryHash} />
    </DatatableContextProvider>
  );
};

export default AllQueries;
